import React from "react";
import styled from "styled-components";
import { shallow } from "zustand/shallow";
import { Box } from "@mantine/core";

import logo from "@assets/images/lets-ride-logo.png";
import vehicleDataEffortLogo from "@assets/images/vehicle-data-effort-logo.png";
import useAppStore from "@components/Microsite/microsite-store";
import { getPlacementImage } from "@components/Asset/helpers";
import { placementDefs } from "@components/Asset/placementDefs";

export default function RideChallengeHeader() {
  const { entityInfo, appConfig } = useAppStore(
    (state) => ({
      entityInfo: state.entityInfo,
      appConfig: state.appConfig,
    }),
    shallow
  );

  const headerLogo = getPlacementImage(
    appConfig,
    entityInfo.assets,
    placementDefs.header_logo
  );

  return (
    <Box mb="sm">
      <StyledLogo src={headerLogo || logo} alt="Logo" />
    </Box>
  );
}

const StyledLogo = styled.img`
  max-width: 300px;
  margin: 0 auto 0 auto;
  max-height: 150px;
  display: block;
`;
